import axios from "axios"
export default (fetch) => {
  return {
    // user-API 组权限-提交申请
    async submit(body) {
      const {data} = await fetch.post('/arcopen/user/company-scope/submit', body)
      if (data.code === 0) {
        return data.data
      } else if (data.code === -500 || !data.message) {
        throw new Error('权限组申请失败')
      } else {
        throw new Error(data.message)
      }
    },
    async scopeList() {
      const {data} = await fetch.get('/arcopen/user/company-scope/scopelist')
      if (data.code === 0) {
        return data.data
      } else if (data.code === -500 || !data.message) {
        throw new Error('权限组列表获取失败')
      } else {
        throw new Error(data.message)
      }
    },
    async configScopeType() {
      const {data} = await fetch.get('/arcopen/user/config/scopetype')
      if (data.code === 0) {
        return data.data
      } else {
        throw new Error('API组列表获取失败')
      }
    },
  }
}

// 查看企业应用权限申请是否可以提交
  const powerWhether = async (data) => {
  const {data: res} = await axios.post('/arcopen/user/company-scope/lock', data)
  if (res.code === 0) {
    return res.data
  } else {
    throw new Error(res.message)
  }
}

export { powerWhether }